// removed by extract-text-webpack-plugin
module.exports = {"header":"_3x32h","header--show":"_10f-5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StickyHeader/StickyHeader.scss
// module id = ./src/components/StickyHeader/StickyHeader.scss
// module chunks = 4